import { designTokens } from './tokens';

export const typography = {
  fontFamily: [
    'Inter',
    'system-ui',
    '-apple-system',
    'BlinkMacSystemFont',
    '"Segoe UI"',
    'Roboto',
    '"Helvetica Neue"',
    'Arial',
    'sans-serif',
  ].join(','),

  fontWeightLight: 300,
  fontWeightRegular: designTokens.fontWeights.regular,
  fontWeightMedium: designTokens.fontWeights.medium,
  fontWeightBold: designTokens.fontWeights.bold,

  h1: {
    fontWeight: designTokens.fontWeights.bold,
    fontSize: designTokens.fontSize['4xl'],
    lineHeight: 1.2,
    letterSpacing: '-0.02em',
  },
  h2: {
    fontWeight: designTokens.fontWeights.bold,
    fontSize: designTokens.fontSize['3xl'],
    lineHeight: 1.25,
    letterSpacing: '-0.02em',
  },
  h3: {
    fontWeight: designTokens.fontWeights.semiBold,
    fontSize: designTokens.fontSize['2xl'],
    lineHeight: 1.3,
    letterSpacing: '-0.01em',
  },
  h4: {
    fontWeight: designTokens.fontWeights.semiBold,
    fontSize: designTokens.fontSize.xl,
    lineHeight: 1.35,
    letterSpacing: '-0.01em',
  },
  h5: {
    fontWeight: designTokens.fontWeights.semiBold,
    fontSize: designTokens.fontSize.lg,
    lineHeight: 1.4,
  },
  h6: {
    fontWeight: designTokens.fontWeights.semiBold,
    fontSize: designTokens.fontSize.base,
    lineHeight: 1.4,
  },

  body1: {
    fontSize: designTokens.fontSize.base,
    lineHeight: 1.5,
  },
  body2: {
    fontSize: designTokens.fontSize.sm,
    lineHeight: 1.5,
  },

  button: {
    fontWeight: designTokens.fontWeights.medium,
    fontSize: designTokens.fontSize.sm,
    textTransform: 'none',
    letterSpacing: '0.02em',
  },

  caption: {
    fontSize: designTokens.fontSize.xs,
    lineHeight: 1.4,
  },

  overline: {
    fontSize: designTokens.fontSize.xs,
    fontWeight: designTokens.fontWeights.semiBold,
    textTransform: 'uppercase',
    letterSpacing: '0.1em',
  },
};
